var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<h1>\n  <div class=\"date\"><span class=\"weekday\">{{ routePlan.date | moment:'llll' }}</span>\n    <button ng-if=\"! routePlan.published &amp;&amp; (auth.roles.planner || auth.roles.clientPlus)\" ng-click=\"openEditRoutePlan(routePlan)\" class=\"edit\"></button>\n  </div>\n  <div class=\"name\">{{ t('distrNo'+routePlan.distrNo) }}</div>\n  <div class=\"name\">{{ routePlan.name }}</div>\n  <div ng-repeat=\"name in customerSystemNames(routePlan.customerSystems)\" class=\"customer-system\">{{ name }}</div>\n</h1>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/pageTitle.jade
 ** module id = 94
 ** module chunks = 1
 **/